import { z } from 'zod';

export const importCallInReqRowSchema = z.object({
  employeeEmail: z.email().max(255),
  employeeName: z.string().trim().min(1).max(255),
  phone: z.coerce.string().regex(/^\d+$/).max(50),
  startDate: z.preprocess(
    (v) => (v instanceof Date ? v : new Date(String(v))),
    z
      .instanceof(Date)
      .refine((d) => !isNaN(d.getTime()), { message: 'Invalid date' })
      .refine((d) => d >= new Date(), { message: 'Start date must be a future date' }),
  ),
});

export type ImportCallInReqRow = z.infer<typeof importCallInReqRowSchema>;
